'use client';

import type { FC } from 'react';
import { useLocalTranslation } from '../hooks/useLocalTranslation';
import translations from './AuctionStats.translations';
import { Credits } from './Credits';
import { formatTimeRemaining } from '../utils/formatters';
import { cn } from '../utils/cn';
import { FaClock, FaTrophy } from './icons';

interface AuctionStatsProps {
  currentBid: number;
  timeRemaining: number;
  className?: string;
}

export const AuctionStats: FC<AuctionStatsProps> = ({ currentBid, timeRemaining, className }) => {
  const { t } = useLocalTranslation(translations);
  const urgent = timeRemaining > 0 && timeRemaining < 60_000;

  return (
    <div className={cn('grid grid-cols-2 gap-3', className)}>
      <div className="rounded-2xl bg-fill-tertiary p-4">
        <div className="flex items-center gap-1.5 text-xs text-label-secondary">
          <FaTrophy className="text-[13px] text-label-tertiary" />
          {t('currentBid')}
        </div>
        <div className="mt-1.5 text-lg font-bold text-label-primary">
          <Credits amount={currentBid} iconSize={16} />
        </div>
      </div>

      <div className="rounded-2xl bg-fill-tertiary p-4">
        <div className="flex items-center gap-1.5 text-xs text-label-secondary">
          <FaClock className="text-[13px] text-label-tertiary" />
          {t('timeRemaining')}
        </div>
        <div className={cn('mt-1.5 text-lg font-bold tabular-nums', urgent ? 'text-accent-red' : 'text-label-primary')}>
          {formatTimeRemaining(timeRemaining, t('ended'))}
        </div>
      </div>
    </div>
  );
};
